/**
 * @import { Filters } from '@/features/world-map/types/filters'
 * @import { Place } from '@/features/world-map/types/place'
 */

import { config } from '@/config/config';
import { api } from '@/lib/api-client';
import { checkErrorCode } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';

/**
 * @typedef {object} PlacesResponse
 * @property {number} [errorCode]
 * @property {Place[]} data
 */

const path = `places/${config.office}/${config.currencyCode}`;

/**
 * @param {Filters} filters
 */
export function usePlaces(filters) {
  return useQuery({
    queryKey: [path, filters],
    queryFn: async ({ signal }) => {
      const response = await api.post(path, filters, { signal });
      const content = /** @type {{ data: Place[] }} */ (await response.json());
      checkErrorCode(content);
      return content.data;
    },
  });
}
